module.exports = __webpack_public_path__ + "img/imgloading.236fa088.gif";